import React from 'react';
import { DollarSign, FileText, Send, Trash2, Calendar, Clock, Check, X, AlertCircle } from 'lucide-react';
import './PendingActionsBanner.css';

const ACTION_ICONS = {
    UPDATE_PRICE: <DollarSign size={24} />,
    UPDATE_KNOWLEDGE: <FileText size={24} />,
    SEND_CAMPAIGN: <Send size={24} />,
    DELETE_ITEM: <Trash2 size={24} />,
    BOOK_MEETING: <Calendar size={24} />,
};

const formatTimeAgo = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diffInMinutes = Math.floor((date - now) / (1000 * 60));

    if (diffInMinutes > 60) {
        const hours = Math.floor(diffInMinutes / 60);
        return `in ${hours} hour${hours > 1 ? 's' : ''}`;
    }
    return `in ${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''}`;
};

function PendingActionsBanner({ actions, onConfirm, onCancel }) {
    if (!actions || actions.length === 0) return null;

    return (
        <div className="pending-actions-banner">
            <h3 style={{ marginTop: 0, marginBottom: '1rem', color: '#d97706', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Clock size={20} /> Pending AI Actions ({actions.length} require confirmation)
            </h3>
            <div className="actions-list">
                {actions.map(action => (
                    <div key={action.id || action._id} className="action-card">
                        <div className="action-type-icon">
                            {ACTION_ICONS[action.action_type] || <AlertCircle size={24} color="#64748b" />}
                        </div>
                        <div className="action-details">
                            <div className="action-header">
                                <span className="action-type-label">{action.action_type.replace('_', ' ')}</span>
                                <span className="action-expires">
                                    Expires {formatTimeAgo(action.expires_at)}
                                </span>
                            </div>
                            <p className="action-preview">
                                {action.original_message || `Action to update ${action.action_type}`}
                            </p>

                            <div className="action-data-preview">
                                {Object.entries(action.parsed_data || {}).map(([key, val]) => (
                                    <span key={key} className="data-chip">
                                        <strong>{key}:</strong> {typeof val === 'object' ? JSON.stringify(val) : String(val)}
                                    </span>
                                ))}
                            </div>
                        </div>
                        <div className="action-buttons">
                            <button className="btn success" style={{ display: 'flex', alignItems: 'center', gap: '6px' }} onClick={() => onConfirm(action.id || action._id)}>
                                <Check size={16} /> Confirm
                            </button>
                            <button className="btn danger" style={{ display: 'flex', alignItems: 'center', gap: '6px' }} onClick={() => onCancel(action.id || action._id)}>
                                <X size={16} /> Cancel
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PendingActionsBanner;
